export const FEED_BACK_ACTION = "FEED_BACK_ACTION";
